import React from "react";

import { COLOR } from "../../component.constants";

export interface Props {
    color: COLOR;
    width?: number;
    height?: number;
    viewBoxWidth?: number;
    viewBoxHeight?: number;
}

const ArticleIcon: React.FC<Props> = ({ color, width, height, viewBoxWidth, viewBoxHeight }) => {
    return (
        <svg
            width={width ?? 24}
            height={height ?? 24}
            viewBox={`0 0 ${viewBoxWidth ?? 24} ${viewBoxHeight ?? 24}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            data-testid="article-icon"
        >
            <path
                d="M19 2.5a1.001 1.001 0 0 1 .956 1.294c-.927 3.011-.59 5.313-.157 7.85.436 2.556.974 5.357.18 9.066-.1.46-.508.79-.979.79H5a1 1 0 0 1-.977-1.21c.704-3.29.243-5.74-.196-8.31-.441-2.586-.855-5.286.218-8.774l.06-.151A1 1 0 0 1 5 2.5h14Zm-13.24 2c-.674 2.674-.36 4.808.039 7.145.388 2.27.853 4.733.395 7.855h11.977c.48-2.901.06-5.16-.344-7.52-.385-2.258-.75-4.6-.122-7.48H5.761ZM15 10H8V8h7v2Z"
                fill={color}
            />
        </svg>
    );
};

export default ArticleIcon;
